/**
 * API Client for IPRanker
 * Handles communication with IPRanker backend API
 */

import type { AnalysisResult, FingerprintData, BehaviorData, DeviceData } from '../types';

export interface AnalyzePayload {
  ip?: string;
  fingerprint: FingerprintData;
  behavior: BehaviorData | null;
  device: DeviceData;
  includeRawData?: boolean;
}

export class APIClient {
  constructor(
    private baseURL: string,
    private apiKey: string
  ) {}

  /**
   * Send analysis request to IPRanker API
   */
  async analyze(payload: AnalyzePayload): Promise<AnalysisResult> {
    const startTime = Date.now();

    try {
      const response = await fetch(`${this.baseURL}/analyze`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': this.apiKey
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const result = await response.json();
      const responseTime = Date.now() - startTime;

      return {
        ...result,
        responseTime
      };
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`IPRanker API request failed: ${error.message}`);
      }
      throw error;
    }
  }
}
